
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"46","viewBox":"0 0 60 46"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#BBCDE5","d":"M18.849 36.224L4.776 22.151 0 26.926l18.849 18.85 40.5-40.5L54.574.5z"}})])
          )
        }
      }
    